module.exports = __webpack_public_path__ + "static/media/antivirals.7342748d.jpg";